var map = {
	"./AKanban.svg": 93734,
	"./Agile.svg": 39351,
	"./Analysis.svg": 23552,
	"./Analytic.svg": 13863,
	"./Appreciation.svg": 37432,
	"./Bill.svg": 49599,
	"./Brief Project.svg": 12529,
	"./Coaching.svg": 52594,
	"./Collaboration.svg": 93765,
	"./Contract.svg": 52584,
	"./Creativity.svg": 63282,
	"./Deployment.svg": 76562,
	"./File Security.svg": 11875,
	"./Guide Book.svg": 23567,
	"./ID card.svg": 34403,
	"./Innovative.svg": 28485,
	"./List.svg": 79568,
	"./Manager.svg": 91295,
	"./Message.svg": 46515,
	"./Production.svg": 42558,
	"./Profile.svg": 22269,
	"./Schedule.svg": 27462,
	"./Skill.svg": 5212,
	"./Sprint.svg": 816,
	"./Task flow.svg": 19719,
	"./Team Brainstorming.svg": 60487,
	"./Time Management.svg": 84723,
	"./Workflow.svg": 60578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14360;